// components/ConcepcaoContent.jsx
import Grid from "@mui/material/Grid";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";
import Box from "@mui/material/Box";
import ReactPlayer from "react-player";

function ConcepcaoContent() {
  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
        <MKBadge
          variant="contained"
          color="info"
          badgeContent="Bassanezi"
          container
          sx={{ mb: 2 }}
          style={{ fontSize: "2rem !important" }}
        />
        <MKTypography variant="h2" fontWeight="bold">
          Bassanezi
        </MKTypography>
        <MKTypography variant="body1" color="text">
          Assume a Modelagem Matemática como arte de transformar problemas da realidade em problemas
          matemáticos e resolvê-los interpretando suas soluções na linguagem do mundo real.
        </MKTypography>
        <br />
        <MKTypography variant="h2" fontWeight="bold">
          Etapas de trabalho
        </MKTypography>
        <MKTypography variant="body1" color="text">
          O autor sugere cinco etapas: Experimentação; Abstração; Resolução; Validação; Modificação.
        </MKTypography>
        <br />
        <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
          <ReactPlayer
            url="https://youtu.be/5_E-xPtpEHk"
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
            controls
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
        <MKBadge
          variant="contained"
          color="info"
          badgeContent="Barbosa"
          container
          sx={{ mb: 2 }}
          style={{ fontSize: "2rem !important" }}
        />
        <MKTypography variant="h2" fontWeight="bold">
          Barbosa
        </MKTypography>
        <MKTypography variant="body1" color="text">
          Assume a Modelagem Matemática como um ambiente de aprendizagem investigativo.
        </MKTypography>
        <br />
        <MKTypography variant="h2" fontWeight="bold">
          Etapas de trabalho
        </MKTypography>
        <MKTypography variant="body1" color="text">
          <strong>Caso 1:</strong> professor apresenta problema e dados
          <br />
          <strong>Caso 2:</strong> professor apresenta apenas o problema
          <br />
          <strong>Caso 3:</strong> projetos com temas livres
        </MKTypography>
        <br />
        <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
          <ReactPlayer
            url="https://youtu.be/884bv_7Y7Xo"
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
            controls
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default ConcepcaoContent;
